// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"4175f8ca","322":"4f26aac2","410":"e9b1c6e7","511":"e6b0c2c6","604":"a2198b37","763":"d1ddf2b3","808":"78cdb88b","873":"ffaa0193","969":"d60a33a4","994":"ad8da68f"}[chunkId] + ".chunk.js";
};